/* eslint-disable no-restricted-globals */
// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

// import {uuid} from "uuidv4";

var CACHE_NAME = process.env.REACT_APP_CACHE_NAME;

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  // process.env.NODE_ENV === "production" &&
  if ("serviceWorker" in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            "This web app is being served cache-first by a service " +
              "worker. To learn more, visit https://bit.ly/CRA-PWA"
          );
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  } else {
    console.log("Service Worker is not supported by browser.");
  }
}

// Register SW
function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log("Worker registration successful", registration.scope);
      const registerPushUpdateEvent = new Event("register-push-app-update");
      //Register push-app-update event listener once the service worker is registered
      self.addEventListener("register-push-app-update", () => initUpdateListener());

      self.dispatchEvent(registerPushUpdateEvent);

      registration.update();
      // Check for updates every 5 min.
      setInterval(() => {
        registration.update();
        console.debug("Checked for update...");
      }, 1000 * 60 * 5);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                "New content is available and will be used when all " +
                  "tabs for this page are closed. See https://bit.ly/CRA-PWA."
              );

              // Notifying user to reload app
              const pushUpdateEvent = new CustomEvent("push-app-update", {
                detail: { registration },
              });
              self.dispatchEvent(pushUpdateEvent);

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log("Content is cached for offline use.");

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }

          if (installingWorker.state === "activated") {
            send(registration).catch((err) => console.error(err));
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log("No internet connection found. App is running in offline mode.");
    });
}

// Unregister SW
export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}

//Register Push, Send Push - for welcome and app updated notification
async function send(registration, isUpdate) {
  // Register Push
  try {
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(process.env.REACT_APP_VAPID_PUBLIC_KEY),
    });

    const URL = `${process.env.REACT_APP_SERVER_URL}/api/v1/web-push/${
      !isUpdate ? "subscribe" : "app-updated"
    }`;
    //Send Push Notification
    await fetch(URL, {
      method: "POST",
      body: JSON.stringify(subscription),
      headers: {
        "content-type": "application/json",
      },
    }).catch((error) => console.log("Push notification failed!", error));
  } catch (err) {
    console.log("Push registration failed", err);
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Push a web app update notification
function initUpdateListener() {
  self.addEventListener("push-app-update", ({ detail }) => {
    if (detail.registration) {
      self.dispatchEvent(
        new CustomEvent("show-update-popup", {
          detail: {
            onConfirm: () => detail.registration?.waiting?.postMessage({ type: "SKIP_WAITING" }),
          },
        })
      );
    }
  });

  // Actions as per notification click
  self.addEventListener("update-notification-click", async function ({ detail }) {
    console.log("update-notification-click", detail);
    if (!detail.action) {
      // Was a normal notification click
      console.log("Notification Click was normal.");
      return;
    }

    switch (detail.action) {
      case "update-app":
        console.log("Updating app...");
        (function () {
          var cookies = document.cookie.split("; ");
          for (var c = 0; c < cookies.length; c++) {
            var d = window.location.hostname.split(".");
            while (d.length > 0) {
              var cookieBase =
                encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
                "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
                d.join(".") +
                " ;path=";
              var p = location.pathname.split("/");
              document.cookie = cookieBase + "/";
              while (p.length > 0) {
                document.cookie = cookieBase + p.join("/");
                p.pop();
              }
              d.shift();
            }
          }
        })();
        window.localStorage.clear();
        if (caches) {
          caches
            .keys()
            .then((cacheNames) => {
              return Promise.all(
                cacheNames.map((cacheName) => {
                  if (cacheName === CACHE_NAME) {
                    return caches.delete(cacheName);
                  }
                  return "";
                })
              );
            })
            .catch((err) => {
              console.error(err);
            });
        }
        if ("serviceWorker" in navigator) {
          // navigator.serviceWorker.ready
          //   .then((registration) => {
          //     registration.update().then(() => {
          //       window.location.reload();
          //     });
          //   })
          navigator.serviceWorker
            .getRegistrations()
            .then(function (registrations) {
              for (let registration of registrations) {
                registration.update();
              }
              navigator.serviceWorker
                .getRegistration(window.location.href)
                .then((registration) => {
                  send(registration, true).catch((err) => console.error(err));
                })
                .catch(() => console.log("Problem occured in updating SW"));
              detail.callback();
              console.log("App updated!!");
              window.location.reload();
            })
            .catch((err) => {
              console.log("Error while updating the app" + err);
              detail.callback();
            });
        }
        break;
      case "not-update-app":
        console.log("App not up to date!");
        detail.callback();
        break;
      default:
        console.log(`Unknown action clicked`);
        break;
    }
  });
}
